import React from 'react';
import { Link } from 'react-router-dom';
import paths from '../../navigation/paths';

const Home: React.FC = () => (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div>{process.env.REACT_APP_IS_ADMIN ? 'ADMIN' : 'CLIENT'}</div>
        <div>Home page</div>
        <Link to={`${paths.review}`}>Go to the review</Link>
    </div>
);

export default Home;
